import { LogoText } from "@/assets";
import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

interface GenerateImageProps {
  viewRef: React.RefObject<HTMLDivElement>;
  accuracy: number;
  data: {
    data?: {
      result?: {
        submitted?: {
          language?: string;
        };
      };
    };
  };
}

export const GenerateImage: React.FC<GenerateImageProps> = ({
  viewRef,
  accuracy,
  data,
}) => {
  const language = data?.data?.result?.submitted?.language || "language";
  const scorePercent = Math.round(accuracy * 100);

  return (
    <div className="generate-image-wrapper">
      <div ref={viewRef} className="generate-image-container">
        <img
          src={require("@/assets/scorecard.png")}
          alt="logo"
          className="logo-image"
        />
        <h2 className="title">I Just Completed A Lesson In {language}</h2>

        <div className="progress-circle-wrapper">
          <CircularProgressbar
            strokeWidth={12}
            value={scorePercent}
            text={""}
            styles={buildStyles({
              pathColor: "#00FFAF",
              trailColor: "#E1E8ED",
              textSize: "16px",
              strokeLinecap: "round",
            })}
            counterClockwise={true}
          />
          <div className="accuracy-text">
            <div>My Score</div>
            <div className="percentage">{scorePercent}%</div>
          </div>
        </div>

        <h3 className="title">Start Your Learning Journey Now</h3>
        <div style={{ zIndex: 1 }}>
          <LogoText height={50} width={160} />
        </div>
      </div>
    </div>
  );
};
